import { render, staticRenderFns } from "./addRecord.vue?vue&type=template&id=4c56a7d4&scoped=true&"
import script from "./addRecord.vue?vue&type=script&lang=js&"
export * from "./addRecord.vue?vue&type=script&lang=js&"
import style0 from "./addRecord.vue?vue&type=style&index=0&id=4c56a7d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c56a7d4",
  null
  
)

export default component.exports